module.exports = __webpack_public_path__ + "img/6users_layout_mobile.529248e6.png";